document.addEventListener('DOMContentLoaded', function() {

  var mainImg = document.querySelector('.product-main-img img');
  var thumbs = document.querySelectorAll('.product-thumb img');
  var optionBtns = document.querySelectorAll('.product-option-btn');
  var optionGroups = document.querySelectorAll('.product-options');
  var select = document.querySelector('select[name="id"]');
  var priceContainer = document.querySelector('.product-price');
  var addBtn = document.querySelector('.product-add-btn');
  var variantDataEl = document.querySelector('[data-product-variants]');
  var variantData = [];
  if (variantDataEl) {
    try { variantData = JSON.parse(variantDataEl.textContent); } catch (e) { variantData = []; }
  }

  function findVariant(id) {
    for (var i = 0; i < variantData.length; i++) {
      if (String(variantData[i].id) === String(id)) return variantData[i];
    }
    return null;
  }
  function findVariantByValues(values) {
    var title = values.join(' / ').toLowerCase();
    for (var i = 0; i < variantData.length; i++) {
      if (String(variantData[i].title).trim().toLowerCase() === title) return variantData[i];
    }
    return null;
  }
  function pageSelectedValues() {
    return Array.prototype.map.call(optionGroups, function(group) {
      var active = group.querySelector('.product-option-btn.active') || group.querySelector('.product-option-btn');
      return active ? active.textContent.trim() : '';
    });
  }

  var stickyPrice = document.getElementById('stickyBuyPrice');

  function renderPrice(variant) {
    if (!priceContainer || !variant) return;
    var html = '<span class="product-price-amount">' + variant.price_html + '</span>';
    if (variant.compare_at_html) {
      html += '<span class="product-compare">' + variant.compare_at_html + '</span>';
      html += '<span class="product-sale-badge">SALE</span>';
    }
    priceContainer.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = variant.price_html;
  }

  function renderAvailability(variant) {
    if (!addBtn || !variant) return;
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
  }

  // OPTION BUTTONS ON THE PAGE
  optionBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.product-options');
      if (group) {
        group.querySelectorAll('.product-option-btn').forEach(function(b) { b.classList.remove('active'); });
      }
      btn.classList.add('active');
      var variant = findVariantByValues(pageSelectedValues());
      if (variant && select) select.value = variant.id;
      renderPrice(variant);
      renderAvailability(variant);
    });
  });

  // GALLERY: thumbnails + tap/swipe main image
  var galleryIndex = 0;
  var counter = null;
  function bigSrc(src) { return src.replace('200x200', '1000x1000').replace('_200x', '_1000x'); }
  function showImage(i) {
    if (!mainImg || !thumbs.length) return;
    galleryIndex = (i + thumbs.length) % thumbs.length;
    mainImg.src = bigSrc(thumbs[galleryIndex].src);
    mainImg.alt = thumbs[galleryIndex].alt;
    if (counter) counter.textContent = (galleryIndex + 1) + ' / ' + thumbs.length + '  \u203a';
  }
  if (mainImg && thumbs.length > 1) {
    counter = document.createElement('span');
    counter.className = 'hb-img-count';
    counter.textContent = '1 / ' + thumbs.length + '  \u203a';
    mainImg.parentElement.appendChild(counter);
    mainImg.addEventListener('click', function() { showImage(galleryIndex + 1); });
    var startX = null;
    mainImg.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    mainImg.addEventListener('touchend', function(e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) showImage(galleryIndex + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });
  }
  thumbs.forEach(function(thumb, i) {
    thumb.parentElement.addEventListener('click', function() { showImage(i); });
  });

  // QTY BUTTONS
  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wrap = btn.closest('.qty-input');
      var num = wrap.querySelector('.qty-num');
      var input = wrap.querySelector('input[name="quantity"]');
      var val = parseInt(num.textContent) || 1;
      if (btn.dataset.action === 'minus' && val > 1) val--;
      if (btn.dataset.action === 'plus') val++;
      num.textContent = val;
      if (input) input.value = val;
    });
  });

  // ---------- ALWAYS-ON BUY BAR + OPTION SHEET ----------
  var stickyBar = document.getElementById('stickyBuyBar');
  var stickyBtn = document.getElementById('stickyBuyBtn');
  if (!stickyBar || !stickyBtn) return;

  stickyBar.classList.add('visible', 'hb-always');
  document.body.classList.add('hb-sticky-on');

  var labels = document.querySelectorAll('.product-option-label');
  var groups = Array.prototype.map.call(optionGroups, function(group, gi) {
    return {
      name: labels[gi] ? labels[gi].textContent.trim() : 'Option',
      values: Array.prototype.map.call(group.querySelectorAll('.product-option-btn'), function(b) { return b.textContent.trim(); }),
      pageButtons: group.querySelectorAll('.product-option-btn')
    };
  });
  var sel = pageSelectedValues();

  function esc(s) { return String(s).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function iconFor(v, gName) {
    if (/\buk\b/i.test(v)) return '\uD83C\uDDEC\uD83C\uDDE7';
    if (/\beu\b/i.test(v)) return '\uD83C\uDDEA\uD83C\uDDFA';
    if (/duo|2\s*\u00d7|2x/i.test(v)) return '\uD83C\uDF81';
    if (/pack|heatbox/i.test(gName + v)) return '\uD83C\uDF71';
    return '';
  }
  function subFor(v) {
    if (/\buk\b/i.test(v)) return 'UK 3-pin sockets';
    if (/\beu\b/i.test(v)) return 'Mainland Europe sockets';
    if (/duo|2\s*\u00d7/i.test(v)) return 'One for you, one to gift';
    if (/^1\b/.test(v)) return 'Just for you';
    return '';
  }

  var backdrop = document.createElement('div');
  backdrop.className = 'hb-sheet-backdrop';
  var sheet = document.createElement('div');
  sheet.className = 'hb-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose your options');
  document.body.appendChild(backdrop);
  document.body.appendChild(sheet);

  var titleEl = document.querySelector('.product-title');
  var productName = titleEl ? titleEl.textContent.trim() : '';

  function render() {
    var v = findVariantByValues(sel) || findVariant(select ? select.value : null);
    var html = '<div class="hb-sheet-grab"></div><button type="button" class="hb-sheet-close" aria-label="Close">\u2715</button>';
    html += '<div class="hb-sheet-head">' + (mainImg ? '<img src="' + esc(mainImg.currentSrc || mainImg.src) + '" alt="">' : '') +
      '<div><div class="hb-sheet-kicker">Almost yours \uD83D\uDD25</div><div class="hb-sheet-title">' + esc(productName) + '</div></div></div>';

    groups.forEach(function(g, gi) {
      html += '<div class="hb-step"><div class="hb-step-label"><span class="hb-step-num done">\u2713</span>' +
        (gi === 0 && groups.length > 1 ? 'Choose your ' : 'Pick your ') + esc(g.name.toLowerCase()) + '</div><div class="hb-opts">';
      g.values.forEach(function(val) {
        var combo = sel.slice(); combo[gi] = val;
        var cv = findVariantByValues(combo);
        var best = /best value/i.test(val);
        var name = val.replace(/\s*[\u2013-]\s*best value/i, '');
        var showPrice = cv && g.values.some(function(other) {
          var c2 = sel.slice(); c2[gi] = other; var ov = findVariantByValues(c2);
          return ov && ov.price_html !== cv.price_html;
        });
        html += '<button type="button" class="hb-opt' + (sel[gi] === val ? ' active' : '') + '" data-g="' + gi + '" data-v="' + esc(val) + '"' + (cv && !cv.available ? ' disabled' : '') + '>' +
          (best ? '<span class="hb-opt-badge">BEST VALUE</span>' : '') +
          '<span class="hb-opt-check"></span>' +
          (iconFor(val, g.name) ? '<span class="hb-opt-icon">' + iconFor(val, g.name) + '</span>' : '') +
          '<span class="hb-opt-name">' + esc(name) + '</span>' +
          (subFor(val) ? '<span class="hb-opt-sub">' + subFor(val) + '</span>' : '') +
          (showPrice ? '<span class="hb-opt-price"><b>' + cv.price_html + '</b>' + (cv.compare_at_html ? '<s>' + cv.compare_at_html + '</s>' : '') + '</span>' : '') +
          (cv && !cv.available ? '<span class="hb-opt-sub">Sold out</span>' : '') +
          '</button>';
      });
      html += '</div></div>';
    });

    var ok = v && v.available;
    html += '<button type="button" class="hb-sheet-cta"' + (ok ? '' : ' disabled') + '>' +
      (ok ? 'Add to cart \u00b7 ' + v.price_html : 'Sold out') + '</button>';
    html += '<div class="hb-sheet-trust"><span>\uD83D\uDE9A Free tracked delivery</span><span>\uD83D\uDD12 30-day money-back</span><span>\uD83D\uDCB3 Secure checkout</span></div>';
    sheet.innerHTML = html;
  }

  function syncPage(gi, val) {
    Array.prototype.forEach.call(groups[gi].pageButtons, function(b) {
      if (b.textContent.trim() === val && !b.classList.contains('active')) b.click();
    });
  }

  function openSheet() {
    sel = pageSelectedValues();
    render();
    document.body.classList.add('hb-sheet-lock');
    backdrop.classList.add('open');
    requestAnimationFrame(function() { sheet.classList.add('open'); });
  }
  function closeSheet() {
    sheet.classList.remove('open');
    backdrop.classList.remove('open');
    document.body.classList.remove('hb-sheet-lock');
  }

  function goCart(btn) {
    var v = findVariantByValues(sel) || findVariant(select ? select.value : null);
    if (!v) return;
    btn.disabled = true;
    btn.textContent = 'Adding to cart\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    }).then(function(res) {
      if (!res.ok) throw new Error('add failed');
      btn.textContent = '\u2713 Added \u2014 opening your cart\u2026';
      // Give Shopify time to send the Add to cart event to Meta/Clarity, then show the cart (not checkout) so shoppers can review first
      setTimeout(function() { window.location.href = '/cart'; }, 900);
    }).catch(function() {
      btn.disabled = false;
      btn.textContent = 'Something went wrong \u2014 try again';
    });
  }

  sheet.addEventListener('click', function(e) {
    var opt = e.target.closest('.hb-opt');
    if (opt && !opt.disabled) {
      var gi = parseInt(opt.getAttribute('data-g'), 10);
      var val = opt.getAttribute('data-v');
      sel[gi] = val;
      syncPage(gi, val);
      render();
      return;
    }
    if (e.target.closest('.hb-sheet-close')) { closeSheet(); return; }
    var cta = e.target.closest('.hb-sheet-cta');
    if (cta && !cta.disabled) goCart(cta);
  });
  backdrop.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeSheet(); });

  stickyBtn.textContent = 'Add to cart';
  stickyBtn.addEventListener('click', function() {
    if (!groups.length) { goCart(stickyBtn); return; }
    openSheet();
  });
});
